import styled from 'styled-components';

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export const AddProposalContainer = styled.div.attrs({})`
  padding: 20px 0px;
`;

export const ButtonsAndInputWrapper = styled.div.attrs({})`
  display: grid;
  gap: 20px;
`;

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 5px;
  border-left: 2px solid #e2e8f0;
  margin-left: 10px;
  gap: 20px;
`;

export const TimelineItem = styled.div`
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    position: absolute;
    left: -11px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #3182ce;
    border: 2px solid #ffffff;
  }
`;

export const TimelineContent = styled.div`
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;
